
<input class="datepick" v-model="value" type="text" :placeholder="placeholder">
